import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "daily-free-content my-5" }
const _hoisted_2 = { class: "row g-0 daily-free-form-row border-bottom border-bottom-dashed" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row g-0 daily-free-form-row border-bottom border-bottom-dashed" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "row g-0 daily-free-form-row border-bottom border-bottom-dashed" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "mt-3 py-3" }
const _hoisted_15 = { class: "small text-scrondary" }
const _hoisted_16 = {
  key: 0,
  class: "border border-5 border-success rounded p-2 text-center bg-success bg-opacity-75"
}
const _hoisted_17 = {
  key: 1,
  class: "border border-5 border-danger rounded p-2 text-center bg-danger bg-opacity-75"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LargeCheckBox = _resolveComponent("LargeCheckBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"daily-free-header rounded-top-lg lh-1\"><div class=\"row\"><div class=\"col\">時段</div><div class=\"col text-center\">平日</div><div class=\"col text-center\">週六</div><div class=\"col text-center\">例假日</div></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col text-center pe-2 fw-bold" }, [
        _createElementVNode("div", { class: "fs-5 lh-1" }, "早班"),
        _createElementVNode("div", { class: "small" }, "5:00~11:00")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_LargeCheckBox, {
          modelValue: _ctx.form.NorMorning,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.NorMorning) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_LargeCheckBox, {
          modelValue: _ctx.form.SatMorning,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.SatMorning) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_LargeCheckBox, {
          modelValue: _ctx.form.SunMorning,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.SunMorning) = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col text-center pe-2 fw-bold" }, [
        _createElementVNode("div", { class: "fs-5 lh-1" }, "午班"),
        _createElementVNode("div", { class: "small" }, "12:00~17:00")
      ], -1)),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_LargeCheckBox, {
          modelValue: _ctx.form.NorAfternoon,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.NorAfternoon) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_LargeCheckBox, {
          modelValue: _ctx.form.SatAfternoon,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.SatAfternoon) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_LargeCheckBox, {
          modelValue: _ctx.form.SunAfternoon,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.SunAfternoon) = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col text-center pe-2 fw-bold" }, [
        _createElementVNode("div", { class: "fs-5 lh-1" }, "晚班"),
        _createElementVNode("div", { class: "small" }, "18:00~23:00")
      ], -1)),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_LargeCheckBox, {
          modelValue: _ctx.form.NorNight,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.NorNight) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_LargeCheckBox, {
          modelValue: _ctx.form.SatNight,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.SatNight) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_LargeCheckBox, {
          modelValue: _ctx.form.SunNight,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.SunNight) = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        class: "btn btn-primary w-100 text-white text-center",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.updateForm && _ctx.updateForm(...args)))
      }, _cache[13] || (_cache[13] = [
        _createElementVNode("span", { class: "fs-5 fw-bold text-spacing-5" }, "送出", -1)
      ])),
      _createElementVNode("div", _hoisted_15, " 最後更新時間：" + _toDisplayString(_ctx.LastUpdateTimeFormat(_ctx.lastUpdateTime)), 1)
    ]),
    (_ctx.pageState.saveSuccess === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[14] || (_cache[14] = [
          _createElementVNode("span", { class: "fs-5 fw-bold" }, "儲存成功", -1)
        ])))
      : _createCommentVNode("", true),
    (_ctx.pageState.saveSuccess === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[15] || (_cache[15] = [
          _createElementVNode("span", { class: "fs-5 fw-bold" }, "儲存失敗", -1)
        ])))
      : _createCommentVNode("", true)
  ]))
}